export const returnFictionAndNotFictionLabel = (typeName) => {
  const types = {
    Dramaturgia: "Ficção",
    Variedades: "Não Ficção",
  };
  return types[typeName] || typeName;
};
